import React from "react";

// items: [{ key, label, onSelect }]
const Tabs = ({ items, activeKey, label = "Sections", className = "" }) => (
  <nav className={["cc-tabs", className].filter(Boolean).join(" ")} aria-label={label}>
    {items.map((item) => {
      const active = item.key === activeKey;
      return (
        <button
          key={item.key}
          type="button"
          className={`cc-tab${active ? " is-active" : ""}`}
          aria-current={active ? "page" : undefined}
          onClick={() => !active && item.onSelect?.()}
        >
          {item.label}
        </button>
      );
    })}
  </nav>
);

export default Tabs;
